// components/layout/services-ui/promo-card.jsx
'use client';

import Link from 'next/link';

export default function PromoCard({ isLight, promo, closeDropdown }) {
    if (!promo) return null;

    const safeHref = (href) => (href?.startsWith('/') ? href : `/${href}`);

    return (
        <div
            className={`h-full rounded-2xl overflow-hidden border ${
                isLight ? 'border-slate-200 bg-slate-50' : 'border-slate-800 bg-slate-900/40'
            }`}
        >
            {/* Optional image */}
            {promo.image ? (
                <div className="relative h-28 w-full">
                    {/* Swap to next/image if you want */}
                    <img src={promo.image} alt="" className="h-full w-full object-cover" />
                    <div
                        className={`absolute inset-0 ${isLight ? 'bg-white/20' : 'bg-black/35'}`}
                    />
                </div>
            ) : (
                <div
                    className={`h-28 w-full ${
                        isLight
                            ? 'bg-gradient-to-br from-slate-100 to-slate-200'
                            : 'bg-gradient-to-br from-blue-600/20 to-purple-600/20'
                    }`}
                />
            )}

            <div className="p-4">
                <p className={`${isLight ? 'text-slate-900' : 'text-white'} text-sm font-semibold`}>
                    {promo.title}
                </p>
                <p className={`${isLight ? 'text-slate-600' : 'text-slate-300'} mt-1 text-xs`}>
                    {promo.subtitle}
                </p>

                {Array.isArray(promo.bullets) && promo.bullets.length ? (
                    <ul className="mt-3 space-y-1.5">
                        {promo.bullets.map((b) => (
                            <li
                                key={b}
                                className={`${isLight ? 'text-slate-600' : 'text-slate-300'} text-xs`}
                            >
                                • {b}
                            </li>
                        ))}
                    </ul>
                ) : null}

                <Link
                    href={safeHref(promo.ctaHref)}
                    onClick={() => closeDropdown()}
                    className={`mt-4 inline-flex w-full items-center justify-center rounded-xl px-3 py-2 text-sm font-semibold transition ${
                        isLight
                            ? 'bg-primary text-white hover:opacity-90'
                            : 'bg-blue-500 text-white hover:bg-blue-400'
                    }`}
                >
                    {promo.ctaLabel}
                </Link>

                {promo.secondaryHref ? (
                    <Link
                        href={safeHref(promo.secondaryHref)}
                        onClick={() => closeDropdown()}
                        className={`mt-2 block text-center text-xs font-semibold ${
                            isLight
                                ? 'text-slate-800 hover:text-primary'
                                : 'text-slate-100 hover:text-blue-300'
                        }`}
                    >
                        {promo.secondaryLabel || 'Learn more'}
                    </Link>
                ) : null}
            </div>
        </div>
    );
}
